/**
 * Default 24 digit hex string ObjectId from Mongo
 */
export const DEFAULT_OBJECT_ID = "000000000000000000000000";
